module.exports = __webpack_public_path__ + "img/yy-success.2313a62f.png";